import { render, staticRenderFns } from "./CompletionDonut.vue?vue&type=template&id=168edbc0&scoped=true&"
import script from "./CompletionDonut.vue?vue&type=script&lang=js&"
export * from "./CompletionDonut.vue?vue&type=script&lang=js&"
import style0 from "./CompletionDonut.vue?vue&type=style&index=0&id=168edbc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168edbc0",
  null
  
)

export default component.exports